// Atalhos de assunto da tela inicial. As famílias e a ordem por app vêm da análise das
// ~369 mil buscas do bot (2022–2026): 22,6% das buscas eram uma palavra só ("planos",
// "integração", "frete"), então o atalho já envia uma pergunta completa sobre o assunto.

export type Assunto =
  | "planos"
  | "importacao"
  | "integracoes"
  | "configuracao"
  | "cancelamento"
  | "conta"
  | "erros"
  | "frete"
  | "pedidos";

type Texto = { pt: string; es: string };

export const Assuntos: Record<Assunto, { rotulo: Texto; pergunta: Texto }> = {
  planos: {
    rotulo: { pt: "Planos e preços", es: "Planes y precios" },
    pergunta: {
      pt: "Quais são os planos e preços do {{app}}?",
      es: "¿Cuáles son los planes y precios de {{app}}?",
    },
  },
  importacao: {
    rotulo: { pt: "Importar produtos", es: "Importar productos" },
    pergunta: {
      pt: "Como importar produtos no {{app}}?",
      es: "¿Cómo importar productos en {{app}}?",
    },
  },
  integracoes: {
    rotulo: { pt: "Integrações", es: "Integraciones" },
    pergunta: {
      pt: "Com quais plataformas o {{app}} integra e como faço a integração?",
      es: "¿Con qué plataformas se integra {{app}} y cómo hago la integración?",
    },
  },
  configuracao: {
    rotulo: { pt: "Configurar e usar", es: "Configurar y usar" },
    pergunta: {
      pt: "Como configurar o {{app}} na minha loja?",
      es: "¿Cómo configurar {{app}} en mi tienda?",
    },
  },
  cancelamento: {
    rotulo: { pt: "Cancelamento e reembolso", es: "Cancelación y reembolso" },
    pergunta: {
      pt: "Como cancelar a assinatura do {{app}} ou pedir reembolso?",
      es: "¿Cómo cancelar la suscripción de {{app}} o pedir un reembolso?",
    },
  },
  conta: {
    rotulo: { pt: "Conta e acesso", es: "Cuenta y acceso" },
    pergunta: {
      pt: "Estou com problema para acessar minha conta do {{app}}. O que faço?",
      es: "Tengo problemas para acceder a mi cuenta de {{app}}. ¿Qué hago?",
    },
  },
  erros: {
    rotulo: { pt: "Algo não funciona", es: "Algo no funciona" },
    pergunta: {
      pt: "O {{app}} não está funcionando na minha loja. Como resolver?",
      es: "{{app}} no está funcionando en mi tienda. ¿Cómo lo soluciono?",
    },
  },
  frete: {
    rotulo: { pt: "Frete e rastreio", es: "Envío y seguimiento" },
    pergunta: {
      pt: "Como funciona o frete e o rastreio no {{app}}?",
      es: "¿Cómo funcionan el envío y el seguimiento en {{app}}?",
    },
  },
  pedidos: {
    rotulo: { pt: "Pedidos e vendas", es: "Pedidos y ventas" },
    pergunta: {
      pt: "Como acompanho os pedidos e vendas no {{app}}?",
      es: "¿Cómo sigo los pedidos y ventas en {{app}}?",
    },
  },
};

// Os 4 assuntos mais buscados de cada app (chave = slugamigavel). Quem não está aqui usa o padrão.
export const AssuntosPorApp: Record<string, Assunto[]> = {
  dropi: ["planos", "importacao", "integracoes", "cancelamento"],
  automagico: ["importacao", "integracoes", "planos", "cancelamento"],
  "lily-reviews": ["importacao", "integracoes", "configuracao", "conta"],
  rastreio: ["frete", "integracoes", "pedidos", "erros"],
  sak: ["conta", "configuracao", "integracoes", "cancelamento"],
  "landing-page": ["configuracao", "integracoes", "pedidos", "cancelamento"],
  "365artes": ["configuracao", "integracoes", "conta", "cancelamento"],
  cheguei: ["configuracao", "integracoes", "conta", "importacao"],
  dijital: ["conta", "integracoes", "cancelamento", "configuracao"],
};

export const AssuntosPadrao: Assunto[] = ["configuracao", "integracoes", "planos", "cancelamento"];
